import { Check } from "lucide-react";

interface StepperProps {
  steps: string[];
  currentStep: number; // 0-indexed
}

export default function Stepper({ steps, currentStep }: StepperProps) {
  return (
    <ol className="flex items-center gap-4 overflow-x-auto pb-2 sm:gap-6">
      {steps.map((label, idx) => {
        const isComplete = idx < currentStep;
        const isActive = idx === currentStep;

        return (
          <li key={label} className="flex items-center gap-2">
            {/* Circle */}
            <span
              className={
                [
                  "flex h-8 w-8 items-center justify-center rounded-full border-2 text-sm font-medium",
                  isComplete
                    ? "border-primary bg-primary text-white"
                    : isActive
                    ? "border-primary bg-white text-primary"
                    : "border-gray-300 bg-white text-gray-400",
                ].join(" ")
              }
            >
              {isComplete ? <Check size={16} /> : idx + 1}
            </span>
            {/* Label */}
            <span
              className={
                [
                  "whitespace-nowrap text-sm font-medium",
                  isComplete || isActive ? "text-gray-900" : "text-gray-400",
                ].join(" ")
              }
            >
              {label}
            </span>
            {idx !== steps.length - 1 && (
              <span className="h-px flex-1 bg-gray-200 sm:w-14" />
            )}
          </li>
        );
      })}
    </ol>
  );
}
